export const GLOBAL_STATE = 'Lesson'

export const LESSON = 'LESSON' as const
export const LESSON_CREATE = 'LESSON_CREATE' as const
export const LESSON_DISTANCE_LEARNING_CREATE = 'LESSON_DISTANCE_LEARNING_CREATE' as const
export const LESSON_DISTANCE_LEARNING_ALL = 'LESSON_DISTANCE_LEARNING_ALL' as const
export const LESSON_DELETE = 'LESSON_DELETE' as const
export const LESSON_LIST = 'LESSON_LIST' as const
export const LESSON_ALL = 'LESSON_ALL' as const
export const LESSON_SORTING = 'LESSON_SORTING' as const
export const LESSON_HOMEWORK_UPLOAD = 'LESSON_HOMEWORK_UPLOAD' as const
export const LESSON_ASSESSMENT = 'LESSON_ASSESSMENT' as const
export const LESSON_ASSESSMENT_ALL = 'LESSON_ASSESSMENT_ALL' as const
export const LESSON_MARK_ASSESSMENT = 'LESSON_MARK_ASSESSMENT' as const
export const LESSON_ASSESSMENT_LIST = 'LESSON_ASSESSMENT_LIST' as const
export const LESSON_DOWNLOAD_FILES = 'LESSON_DOWNLOAD_FILES' as const

export const LESSON_ATTENDANCE = 'LESSON_ATTENDANCE' as const
export const LESSON_ATTENDANCE_GROUP = 'LESSON_ATTENDANCE_GROUP' as const
